export default __webpack_public_path__ + "static/media/digital-store-product-06.433a260e.jpg";